window.addEventListener('DOMContentLoaded', function () {
  if( document.querySelector('.nav-toggle') ) {
    document
      .querySelector('.nav-toggle')
      .addEventListener('click', function (e) {
        var target = e.currentTarget.attributes["data-target"].value;
        document.querySelector(target).parentElement.classList.toggle("show");
        this.classList.toggle('active');
        document.body.classList.toggle('nav-toggle-'+target.replace('#','').replace('.',''));
      }, false)

    var navLink = document.querySelectorAll('.primary li')
    for (var i = 0; i < navLink.length; i++) {
      navLink[i].addEventListener('click', function(event) {
        if( document.body.clientWidth < 750 ) {
          if( event.target.parentElement.querySelector('nav') ) event.preventDefault()
        }
      })
    }
    if( document.querySelector('.navbar-toggle') ) {
      document
        .querySelector('.navbar-toggle')
        .addEventListener('click', function (e) {
          document.querySelector(e.currentTarget.attributes["data-target"].value).parentElement.classList.toggle("show");
          this
            .classList
            .toggle('active')
        }, false)
      
      var navLink = Array.from(document.querySelectorAll("nav-magellan li")).concat(Array.from(document.querySelectorAll("nav-microsite li")))
      for (var i = 0; i < navLink.length; i++) {
        navLink[i].addEventListener('click', function(event) {
          if( document.body.clientWidth < 750 ) {
            if( event.target.parentElement.querySelector('nav') ) event.preventDefault()
          }
        })
      }
    }
  }

  if( document.querySelector('li.search') ) {
  document
    .querySelector('li.search')
    .addEventListener('click', function (e) {

      if (this.classList.contains('active')) {
        if (e.target.nodeName == 'svg' && document.forms[0]) {
          document.forms[0].submit()
        }
      } else {
        this.classList.add('active')
        document.querySelector('nav.magellan').classList.add('search-active')
      }
      document.querySelector('li.search input').focus()

      e.stopPropagation()
    }, false)
  }

  document
    .addEventListener('click', function (e) {
      var s = document.querySelector('li.search')
      if (s.classList.contains('active')) {
        s.classList.remove('active')
        document.querySelector('nav.magellan').classList.remove('search-active')
      }
    })

  var communityEvent = null
  if( document.querySelector('a.submitevent.button') ) {
    document
      .querySelector('a.submitevent.button')
      .addEventListener('click', function(e) {
        document
          .querySelector('nav.magellan')
          .classList
          .remove('show')

        if(communityEvent === null) {

          communityEvent = document.createElement("submit-event")
          communityEvent.classList.add("popup")
          let header = document.querySelector('header.primary')
          header.parentElement
            .insertBefore(communityEvent, header)

        } else {

          communityEvent.remove()
          communityEvent = null

        }
      })
    }
}, false)



// WEBPACK FOOTER //
// ./theme/_base/js/nav.js